import { render, staticRenderFns } from "./UpdateFileModal.vue?vue&type=template&id=283ff061&scoped=true&"
import script from "./UpdateFileModal.vue?vue&type=script&lang=js&"
export * from "./UpdateFileModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283ff061",
  null
  
)

export default component.exports